import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {DynamicFormService} from 'src/app/shared/components/dynamic-forms-components/dynamic-form.service';
import {FieldConfig, FieldType} from 'src/app/shared/components/dynamic-forms-components/field.interface';
import {citizenGetFillableForms} from 'src/app/store/entities/service-management/fillable-form/fillable-form.actions';
import {FillableForm} from 'src/app/store/entities/service-management/fillable-form/fillable-form.model';
import {
  selectModifiedFillableForms
} from 'src/app/store/entities/service-management/fillable-form/fillable-form.selectors';
import {citizenGetServiceSampleForm} from 'src/app/store/entities/service-management/sample-form/sample-form.actions';
import {SampleForm} from 'src/app/store/entities/service-management/sample-form/sample-form.model';
import {selectModifiedSampleForms} from 'src/app/store/entities/service-management/sample-form/sample-form.selectors';
import {AppState} from 'src/app/store/reducers';
import {
  CitizensServices,
  ServiceGroupsTypeEnum
} from "../../../../store/entities/citizens/citizens-services/citizens-services.model";
import {
  citizenGetServiceUploadableForm
} from 'src/app/store/entities/service-management/uploadable-form/uploadable-form.actions';
import {UploadableForm} from 'src/app/store/entities/service-management/uploadable-form/uploadable-form.model';
import {
  selectModifiedUploadableForms
} from 'src/app/store/entities/service-management/uploadable-form/uploadable-form.selectors';
import {environment} from 'src/environments/environment';
import {
  createCitizensFillableFormResponses
} from "../../../../store/entities/citizens/citizens-fillable-form-response/citizens-fillable-form-response.actions";
import {
  citizenGetServiceUploadableFormAttachment
} from "../../../../store/entities/service-management/uploadable-form-attachment/uploadable-form-attachment.actions";
import {
  selectModifiedUploadableFormAttachments
} from "../../../../store/entities/service-management/uploadable-form-attachment/uploadable-form-attachment.selectors";
import {
  UploadableFormAttachment
} from "../../../../store/entities/service-management/uploadable-form-attachment/uploadable-form-attachment.model";
import {AttachmentService} from "../../../../services/attachment.service";
import {
  CitizensUploadableFormRequestInput
} from "../../../../store/entities/citizens/citizens-uploadable-form-request/citizens-uploadable-form-request.model";
import {
  createCitizensUploadableFormRequests
} from "../../../../store/entities/citizens/citizens-uploadable-form-request/citizens-uploadable-form-request.actions";
import {
  ProfileDto,
  ProfileType
} from "../../../../store/entities/instution-settings/instution-user/instution-user.model";
import {StorageService} from "../../../../services/storage.service";
import {
  CitizensServicesGroups
} from "../../../../store/entities/citizens/citizens-services-groups/citizens-services-groups.model";
import {
  CitizensServicesAutomationDetails
} from "../../../../store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.model";
import {
  CitizensServicesProvisionMeans
} from "../../../../store/entities/citizens/citizens-services-provision-means/citizens-services-provision-means.model";

export type GroupInput =
  | ServiceGroupsTypeEnum
  | { groupType: ServiceGroupsTypeEnum }
  | Array<ServiceGroupsTypeEnum | { groupType: ServiceGroupsTypeEnum }>;

@Component({
  selector: 'app-request-forms',
  templateUrl: './request-forms.component.html',
  styleUrls: ['./request-forms.component.scss']
})

export class RequestFormsComponent implements OnInit, OnChanges {

  @Input() fields: FieldConfig[]
  @Input() formUniqueId: string;
  @Input() service: CitizensServices;
  @Input() servicesAutomations: CitizensServicesAutomationDetails[];

  serviceUniqueId: string;
  fillableFormUniqueId: string;

  supportForm: FormGroup;

  fillableForm$: Observable<FillableForm[]>;
  uploadableForm$: Observable<UploadableForm[]>;

  sampleForms$: Observable<SampleForm[]>;
  uploadableFormAttachments$: Observable<UploadableFormAttachment[]>;

  uploadableFormAttachmentFormGroup: FormGroup
  uploadableFormAttachmentIndex = -1

  selectedFiles: {
    fileName: string;
    formIndex: number;
  }[] = []

  userProfile: any
  profileType: string
  citizenType: string
  isPublicServant: boolean
  allowed = false;

  webSystem: CitizensServicesProvisionMeans

  constructor(
    private readonly notificationService: NotificationService,
    private readonly dynamicFormService: DynamicFormService,
    private readonly store: Store<AppState>,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly attachmentService: AttachmentService,
    private readonly storageService: StorageService
  ) {
    this.serviceUniqueId = this.route.snapshot.paramMap.get('serviceUniqueId');
  }

  get serviceAttachments() {
    return this.uploadableFormAttachmentFormGroup.controls["requestCitizenAttachments"] as FormArray;
  }

  ngOnInit(): void {

    this.userProfile = this.storageService.getItem('profile')
    this.profileType = this.storageService.getItem('userType')
    this.citizenType = this.storageService.getItem('citizenType')
    this.isPublicServant = this.storageService.getItem('isPublicServant')

    if (this.servicesAutomations?.length) {
      this.webSystem = this.servicesAutomations[0]?.serviceProvisions?.find((serviceAutomation) => serviceAutomation.serviceProvisionMeans?.toUpperCase() === 'WEB')
    }

    if (this.service?.serviceForm?.formType === 'FILLABLE')
      this.store.dispatch(citizenGetFillableForms({serviceUniqueId: this.serviceUniqueId}))

    // citizen get uploadable services

    if (this.service?.serviceForm?.formType === 'UPLOADABLE') {
      this.uploadableFormAttachmentFormGroup = this.fb.group({
        requestCitizenAttachments: this.fb.array([])
      });
      this.store.dispatch(citizenGetServiceUploadableForm({serviceUniqueId: this.serviceUniqueId}));
    }


    this.fillableForm$ = this.store.select(selectModifiedFillableForms);

    this.uploadableForm$ = this.store.select(selectModifiedUploadableForms)

    this.uploadableForm$.subscribe(data => {
      if (data) {
        if (data.length !== 0) {
          this.store.dispatch(citizenGetServiceSampleForm({formUniqueId: data[0].formUniqueId}));
          this.store.dispatch(citizenGetServiceUploadableFormAttachment({
            formUniqueId: data[0].formUniqueId
          }))
          this.formUniqueId = data[0].formUniqueId
        }
      }
    })

    this.fillableForm$.subscribe((data) => {
      if (data) {
        data?.forEach((dt) => {
          const fieldList: FieldConfig[] = JSON.parse(dt?.configuration);
          this.fields = fieldList?.map((x) => {
            return {
              ...x,
              validations: x?.validations?.find(v => v['name'] === 'required') ? [
                {
                  message: 'Field is required',
                  validator: Validators.required,
                  name: 'required',
                }
              ] : [],
              rowClass: this.rowClassMapper(x?.rowClass?.toLowerCase())
            }
          });
          this.fields?.push({
            type: FieldType.button,
            label: 'Save',
            rowClass: 'col-span-12',
          });
          this.supportForm = this.dynamicFormService.createControl(
            this.fields,
            null
          );
          this.fillableFormUniqueId = dt.uniqueId
        })
      }

    })

    this.sampleForms$ = this.store.select(selectModifiedSampleForms);
    this.uploadableFormAttachments$ = this.store.select(selectModifiedUploadableFormAttachments);

    this.uploadableFormAttachments$.subscribe(data => {
      if (data) {
        if (data.length != 0) {
          for (const datum of data) {
            this.addAttachment({
              attachmentUniqueId: datum.attachmentUniqueId,
              attachmentPath: null,
              attachmentTitle: datum.attachmentTitle,
              attachmentIsMandatory: datum.attachmentIsMandatory
            })
          }
        }
      }
    })

  }

  openWebSystem() {
    window.open(this.webSystem?.serviceReachLink, '_blank');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.profileType) {
      this.profileType = this.storageService.getItem('userType');
      this.citizenType = this.storageService.getItem('citizenType');
    }

    if (changes['service'] && this.service && this.profileType) {
      console.log(this.profileType)

      this.allowed = this.canRequestService(
        {profileType: this.profileType, citizenType: this.citizenType},
        this.service.serviceGroups
      );
    }
  }


  rowClassMapper(rowClass: 'large' | 'medium' | 'small' | string) {
    if (rowClass == "large") return 'col-span-12';
    if (rowClass == "medium") return 'col-span-6';
    if (rowClass == "small") return 'col-span-4';
    return rowClass;
  }

  addAttachment(data: {
    attachmentPath: string,
    attachmentUniqueId: string,
    attachmentTitle: string,
    attachmentIsMandatory: boolean
  } = {
    attachmentPath: null,
    attachmentUniqueId: null,
    attachmentTitle: null,
    attachmentIsMandatory: true
  }) {
    const AttachmentForm = data.attachmentIsMandatory ? this.fb.group({
        attachmentPath: [data.attachmentPath, [Validators.required]],
        attachmentUniqueId: [data.attachmentUniqueId, [Validators.required]],
      })
      : this.fb.group({
        attachmentPath: [data.attachmentPath],
        attachmentUniqueId: [data.attachmentUniqueId],
      });
    this.serviceAttachments.push(AttachmentForm);
  }

  downloadSampleForm(samplepath: string) {
    const url = environment.FILE_SERVER_URL + samplepath
    window.open(url, '_blank')
  }

  submitFillableForm(formData) {
    const attachmentFields = this.fields.filter(field => field.type === FieldType.attachment);

    // console.log(attachmentFields, '--atachment fields')

    attachmentFields.forEach((attachmentField) => {
      if (formData[attachmentField.key]) {
        // Update the formData with the base64 value of the attachment
        formData = {
          ...formData,
          [attachmentField.key]: formData[attachmentField.key].base64,
        };
      }
    });


    // Further processing of formData
    // console.log('Final formData:', formData);

    this.store.dispatch(createCitizensFillableFormResponses({
      input: {
        responsePayload: JSON.stringify(formData),
        serviceUniqueId: this.serviceUniqueId,
        formUniqueId: this.fillableFormUniqueId
      }
    }))

    this.supportForm.reset()
  }

  showLogin() {
    this.storageService.setItem('urlToRedirect', '/service-view/' + this.serviceUniqueId);
    this.router.navigate(['', 'login']);
  }

  submitUploadableForm(formValues: {
    requestCitizenAttachments: { attachmentPath: string, attachmentUniqueId: string }[]
  }) {
    let input: CitizensUploadableFormRequestInput = {
      requestCitizenAttachments: [],
      formUniqueId: this.formUniqueId
    }
    for (const formValue of formValues.requestCitizenAttachments) {
      if (formValue.attachmentPath) input.requestCitizenAttachments.push(formValue)
    }

    this.store.dispatch(createCitizensUploadableFormRequests({
      input
    }))
    this.selectedFiles = []
    this.uploadableFormAttachmentFormGroup = this.fb.group({
      requestCitizenAttachments: this.fb.array([])
    });
    this.uploadableFormAttachments$.subscribe(data => {
      if (data) {
        if (data.length != 0) {
          for (const datum of data) {
            this.addAttachment({
              attachmentUniqueId: datum.attachmentUniqueId,
              attachmentPath: null,
              attachmentTitle: datum.attachmentTitle,
              attachmentIsMandatory: datum.attachmentIsMandatory
            })
          }
        }
      }
    })
  }

  chooseAttachment(index: number, fileInput: any) {
    this.uploadableFormAttachmentIndex = index
    fileInput.click()
  }

  uploadAttachment(file: File) {
    let that = this
    const reader = new FileReader();
    reader.addEventListener('load', async (event) => {

      let response = await that.attachmentService.uploadSingleFile({
        fileName: file.name,
        base64String: event.target.result.toString().split(';base64,')[1]
      })

      if (response.response.status) {

        let currentInputs = this.serviceAttachments.value
        currentInputs = currentInputs.map((item: {
          attachmentPath: string;
          attachmentUniqueId: string;
        }, itemIndex) => {
          return itemIndex === this.uploadableFormAttachmentIndex ? {
            ...item,
            attachmentPath: response.data.imagePath
          } : item
        })
        this.serviceAttachments.setValue(currentInputs)
        this.selectedFiles.push({
          formIndex: this.uploadableFormAttachmentIndex,
          fileName: file.name
        })

      } else {
        await that.notificationService.errorMessage(response.response.message);
      }
    });
    reader.readAsDataURL(file);
  }

  isFileSelected(index: number) {
    let foundIndex = this.selectedFiles.findIndex(item => item.formIndex === index)
    return foundIndex >= 0
  }

  viewFileSelected(index: number) {
    return this.selectedFiles.find(item => item.formIndex === index).fileName
  }

  removeFileSelected(index: number) {
    let foundIndex = this.selectedFiles.findIndex(item => item.formIndex === index)

    if (foundIndex >= 0) {
      this.selectedFiles.splice(foundIndex, 1)
      let currentInputs = this.serviceAttachments.value
      currentInputs = currentInputs.map((item: {
        attachmentPath: string;
        attachmentUniqueId: string;
      }, itemIndex) => {
        return itemIndex === this.uploadableFormAttachmentIndex ? {
          ...item,
          attachmentPath: null
        } : item
      })
      this.serviceAttachments.setValue(currentInputs)
    }
  }

  private static readonly servantGroups: ServiceGroupsTypeEnum[] = [
    ServiceGroupsTypeEnum.Government_to_Citizens,
    ServiceGroupsTypeEnum.Government_to_Government,
    ServiceGroupsTypeEnum.Government_to_Employee,
  ];

  private static readonly accessMap: Record<ProfileType, ServiceGroupsTypeEnum[]> = {
    [ProfileType.INST]: RequestFormsComponent.servantGroups,
    [ProfileType.POPSM]: RequestFormsComponent.servantGroups,
    [ProfileType.Executive]: RequestFormsComponent.servantGroups,
    [ProfileType.CIT]: [ServiceGroupsTypeEnum.Government_to_Citizens],
    [ProfileType.COMPANY]: [ServiceGroupsTypeEnum.Government_to_Business],
  };


  private static toProfileType(v: string | undefined | null): ProfileType | null {
    if (!v) return null;
    return (Object as any).values(ProfileType).includes(v) ? (v as ProfileType) : null;
  }

  private static toGroupCode(v: string | undefined | null): ServiceGroupsTypeEnum | null {
    if (!v) return null;
    if (v.startsWith('G2')) return v as ServiceGroupsTypeEnum;
    return (ServiceGroupsTypeEnum as any)[v] ?? null;
  }


  canRequestService(
    userProfile: { profileType: string; citizenType?: string },
    serviceGroup: CitizensServicesGroups | CitizensServicesGroups[] | null | undefined,
  ): boolean {
    console.log(this.profileType)

    if (!serviceGroup) return false;

    const groups = (Array.isArray(serviceGroup) ? serviceGroup : [serviceGroup])
      .map(g => RequestFormsComponent.toGroupCode(g?.groupType))
      .filter((g): g is ServiceGroupsTypeEnum => !!g);

    if (!groups.length) return false;

    if (userProfile.citizenType === 'Foreigner') {
      return groups.includes(ServiceGroupsTypeEnum.Government_to_foreign);
    }

    const isPublicServant = this.storageService.getItem('isPublicServant')
    if (isPublicServant) {
      return groups.some(g => [ServiceGroupsTypeEnum.Government_to_Citizens,
        ServiceGroupsTypeEnum.Government_to_Government, ServiceGroupsTypeEnum.Government_to_Employee].includes(g));
    }

    const profileKey = RequestFormsComponent.toProfileType(userProfile.profileType);
    if (!profileKey) return false;

    const allowed = RequestFormsComponent.accessMap[profileKey] ?? [];
    return groups.some(g => allowed.includes(g));
  }


  private static toCode(value: string | undefined | null): ServiceGroupsTypeEnum | null {
    if (!value) return null;
    if (value.startsWith('G2')) return value as ServiceGroupsTypeEnum;
    return (ServiceGroupsTypeEnum as any)[value] ?? null;
  }


  protected readonly location = location;
}
